import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <section className="py-32 bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="text-[8rem] font-display font-bold leading-none text-[#0057B8]">404</div>
        <h1 className="mt-4 font-display text-3xl font-bold text-[#111827]">Page not found</h1>
        <p className="mt-2 text-[#6B7280]">The page you're looking for may have moved or no longer exists.</p>
        <Button asChild className="mt-6 bg-[#0057B8] hover:bg-[#003F87] text-white rounded-full btn-brand">
          <Link to="/">Back to Home</Link>
        </Button>
      </div>
    </section>
  );
}
